function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.14 34.597a5.867 5.867 0 1 1 0-11.72 5.86 5.86 0 0 1 0 11.72zm0-10.796a4.944 4.944 0 1 0 4.954 4.93 4.874 4.874 0 0 0-1.462-3.492 4.827 4.827 0 0 0-3.48-1.438h-.012z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.14 31.558a2.837 2.837 0 1 1-.002-5.675 2.837 2.837 0 0 1 .002 5.675zm0-4.737a1.912 1.912 0 1 0 .003 3.823 1.912 1.912 0 0 0-.003-3.822zM14.64 34.597a5.867 5.867 0 1 1 0-11.72 5.86 5.86 0 0 1 0 11.72zm0-10.796a4.944 4.944 0 1 0 4.954 4.93 4.874 4.874 0 0 0-1.462-3.492 4.827 4.827 0 0 0-3.48-1.438h-.012z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.64 31.558a2.837 2.837 0 1 1-.002-5.675 2.837 2.837 0 0 1 .002 5.675zm0-4.737a1.912 1.912 0 1 0 .003 3.823 1.912 1.912 0 0 0-.003-3.822z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54 21.5c4.026 0 5.74 2.49 6.467 4.5M54 21.5c-4.026 0-5.917 2.49-6.788 4.5M54 21.5H3M60.467 26c.492 1.36.533 2.5.533 2.5h2.5V26H63m-2.533 0H63m0 0v-7.5C57 3.5 46 1 24 1H3a2 2 0 0 0-2 2v7.5m2 11H2a1 1 0 0 1-1-1v-10m2 11v1.75m0 3.25H2v2h5.5s.062-.872.429-2M3 26.5h4.929M3 26.5V25m41.5 3.5H44v.5H22s-.15-1.124-.71-2.5m23.21 2h2s.122-1.14.712-2.5M44.5 28.5v-2m2.712-.5H44.5v.5m-36.571 0c.671-2.07 2.365-5 6.571-5 3.985 0 5.902 2.818 6.79 5m0 0H44.5M1 10.5h40.5m0 0V4C49.974 5.08 53.489 7.959 59 14.5H41.5v-4zm1 7h3M3 25h1v-1.75H3M3 25v-1.75",
  stroke: "#E4ECFF"
});

var SvgVan = function SvgVan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 35,
    viewBox: "0 0 64 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/van.b3887ed3.svg";
export { ForwardRef as ReactComponent };